<script>
  import { onMount, onDestroy } from 'svelte';
  import { postError, joinRoom, leaveRoom, createRoom } from '../../js/actions.js';
  import {
    ROOM_NAME_YOUR_ROOM,
    ROOM_ENTER_ROOM_NAME,
    ROOM_ENTER_ROOM_ID,
    ROOM_CREATE_ROOM,
    ROOM_CREATE_A_ROOM,
  } from '../../js/l10n/en_US.js';

  export let source,
    eventId,
    roomName = '',
    roomId = '',
    onClose = () => {},
    token = '';

  $: roomId = roomName
    .replace(/[ ]+/gi, '-')
    .replace(/[^a-zA-Z0-9\-]+/gi, '')
    .toLowerCase();

  async function submitCreateRoom() {
    if (roomName === '') {
      return;
    }
    if (!roomName.trim() || !roomId.trim()) {
      postError(ROOM_FAILED_TO_CREATE_ROOM, ERROR_WARNING);
      return;
    }
    onClose();
    await createRoom(source, eventId, roomId, roomName, token);
  }
</script>

<form class="create-room" on:submit|preventDefault={submitCreateRoom} autocomplete="off">
  <div class="expand-container-title-area">
    <span>{ROOM_CREATE_A_ROOM}</span>
    <i
      class="icon-close"
      on:click={() => {
        onClose();
      }} />
  </div>
  <div class="create-room-name-area">
    <label for="room-name-input">{ROOM_ENTER_ROOM_NAME}</label>
    <input id="room-name-input" bind:value={roomName} aria-label={ROOM_ENTER_ROOM_NAME} />
  </div>
  <!-- <div class="create-room-id-area">
    <input bind:value={roomId} aria-label={ROOM_ENTER_ROOM_ID} placeholder={ROOM_ENTER_ROOM_ID} />
  </div> -->
  <div class="create-room-submit-area">
    <button type="submit" class="btn text-light {roomName === '' ? 'disabled' : ''}">
      {ROOM_CREATE_ROOM}
    </button>
  </div>
</form>
